// Global state for "Customer View Mode" which masks internal/employee-only
// features so employees can see what a customer would see when presenting.
//
// Persisted in sessionStorage so it survives page reloads within a tab
// but resets when the tab is closed.

const STORAGE_KEY = "oneschema:hideInternalFeatures"

function readFromStorage(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

let internalFeaturesHidden = readFromStorage()

export function hideInternalFeatures(): boolean {
  return internalFeaturesHidden
}

export function setHideInternalFeatures(enabled: boolean): void {
  internalFeaturesHidden = enabled
  try {
    if (enabled) {
      sessionStorage.setItem(STORAGE_KEY, "true")
    } else {
      sessionStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // sessionStorage unavailable; in-memory state still works.
  }
}
